import Axios from '../axios'
import appConfig from '../../../app.config'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'

interface IMSUpdateAgreementConditionDto {
	partyId: string
	accountAgreementId: string
	accountConfiguration: {
		productId: string
		conditionValue: {
			conditionIndex: number
			baseAmount: number
			currency: string
		}
	}
}

export async function updateAgreementConditionService(
	updateAgreementConditionPayload: IMSUpdateAgreementConditionDto,
) {
	return Axios.post(
		`${appConfig.customerDataBaseUrl}/api/user/agreement/condition/update`,
		updateAgreementConditionPayload,
		await getHeadersWithJwtToken(),
	)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
